import React, { Component } from 'react';
import Paper from '@mui/material//Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/CloudDownload';
import Button from '@mui/material/Button';
import { Link, withRouter } from 'react-router-dom';




class Bills extends Component {
  state = {

  };

  handleDownloadBill = (bill) => {
    this.props.downloadBill(bill.path)
  }

  render() {
    return (
      <div>
        < AppBar position = "fixed"
        style = {
          {
            marginLeft: 260,
            backgroundColor: "#55565A"
          }
        } >
          <Toolbar>
            <Typography variant="h5" style={{ marginLeft: 260 }}>
              My Bills
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper position="fixed" style={{
          marginTop: 60,
          paddingTop: 30,
          height: 150,
          //width: "100%",
          marginLeft: 260
        }}>
          <Typography variant="h6" style={{ marginLeft: 30, align: "left"}}>
            {
              this.props.bills.length > 0 ? this.props.bills[0].accountNumber : ""
            }
            </Typography>
          <Typography variant="h5" style={{ marginLeft: 30}}>
            Your Outstanding Balance: ${this.props.balance ? this.props.balance.toFixed(2) : ""}
          </Typography>
          {/* <Typography variant="subheading" style={{ marginLeft: 30 }}>
            Due Date: {this.props.bills.length > 0 ? this.props.bills[0].invoiceDueDate.substring(0, 10) : ""}
          </Typography> */}
          < Button
            button component={Link} to={'/payment'}
            
            style={
              {
                background: '#47ED3E',
                fontWeight: 'bold',
                borderRadius: 5,
                border: 0,
                color: '#55565A',
                height: 40,
                padding: '0 30px',
                width: 200,
                marginBottom: 20,
                marginLeft: 30,
                marginTop: 10,
                marginRight: 'auto'
              }
            } >
            PAY BILL
          </Button>
          < Button
            onClick={this.handleDownloadBill.bind(this, this.props.bills[0])}
            style={
              {
                background: '#47ED3E',
                fontWeight: 'bold',
                borderRadius: 5,
                border: 0,
                color: '#55565A',
                height: 40,
                padding: '0 30px',
                width: 200,
                marginBottom: 20,
                marginLeft: 10,
                marginTop: 10,
                marginRight: 'auto'
              }
            } >
            LATEST BILL
          </Button>
        </Paper>
        <Paper style={{
          //marginTop: 140,
          marginLeft: 260,
          marginBottom: 60
        }}>
          <Table >
          
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Invoice #</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Download</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.bills.map(n => {
                return (
                  <TableRow  key={n.invoiceNumber}>
                    <TableCell >{n.invoiceDate.substring(0,10)}</TableCell>
                    <TableCell >{n.invoiceNumber}</TableCell>
                    <TableCell >${n.totalAmount}</TableCell>
                    <TableCell >
                      <IconButton onClick={this.handleDownloadBill.bind(this, n)}>
                        <DownloadIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

        </Paper>
        
      </div>
    )

  }
}
export default withRouter(Bills)